export default __webpack_public_path__ + "static/media/help-gray.37b45775.svg";